import { createIconComponent } from '../../factory/create-icon-component';
export const DeepIcon = createIconComponent(
  'DeepIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.25 6H3.75M9 17.5L11.5 20M11.5 20V10M11.5 20L14 17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
